import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
const forYou = ['Trabajás por tu cuenta o con un equipo chico.', 'Sabés que cobrás menos de lo que aportás.', 'Querés hablar de precio sin improvisar.', 'Buscás ordenar tu trabajo sin contratar más gente.', 'Querés cambiar tu forma de trabajar en los próximos meses.'];
const notForYou = ['Buscás una respuesta rápida sin cambiar nada.', 'Preferís seguir trabajando como hasta ahora.'];
export function AudienceFit() {
  return <section className="bg-brand-lighter px-6 py-24 lg:px-8" data-id="element-13">
      <div className="mx-auto max-w-5xl" data-id="element-14">
        <h2 className="mb-12 text-center text-3xl font-extrabold text-brand-navy md:text-5xl" data-id="element-15">
          Este sistema es para vos si...
        </h2>
        <div className="grid gap-6 md:grid-cols-2" data-id="element-16">
          <article className="rounded-3xl border border-brand-light bg-white p-7 shadow-soft" data-id="element-17">
            <h3 className="mb-6 text-xl font-extrabold text-brand-navy" data-id="element-18">
              Te sirve si buscás esto
            </h3>
            <ul className="space-y-4" data-id="element-19">
              {forYou.map(item => <li key={item} className="flex items-start gap-3 text-brand-navy/80" data-id="element-20">
                  <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-brand-green" data-id="element-21" />
                  {item}
                </li>)}
            </ul>
          </article>
          <article className="rounded-3xl border border-red-100 bg-red-50 p-7" data-id="element-22">
            <h3 className="mb-6 text-xl font-extrabold text-brand-navy" data-id="element-23">
              No te sirve si buscás esto
            </h3>
            <ul className="space-y-4" data-id="element-24">
              {notForYou.map(item => <li key={item} className="flex items-start gap-3 text-brand-navy/75" data-id="element-25">
                  <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-26" />
                  {item}
                </li>)}
            </ul>
          </article>
        </div>
      </div>
    </section>;
}